document.addEventListener('DOMContentLoaded', () => {
	let servicesSections = document.querySelectorAll('section.services')

	const calcTallest = () => {
		servicesSections?.forEach(section => {
			let services = section.querySelectorAll('.service')
			let tallest = 0
			services?.forEach(service => {
				let visible = service.querySelector('.content .visible')
				section.setAttribute('style', `--tallest: auto;`) // This part is necessary to actually recalculate the tallest .visible element on window resize
				visible.setAttribute(
					'style',
					`--default-height: ${visible.scrollHeight}px;`
				)
				tallest =
					visible.scrollHeight > tallest ? visible.scrollHeight : tallest
			})
			section.setAttribute('style', `--tallest: ${tallest}px;`)
		})
	}

	calcTallest(servicesSections)

	window.addEventListener('resize', calcTallest)
})
